<template>
  <div class="video-player">
    <ScriptYouTubePlayer
      ref="video"
      :key="getYouTubeVideoId(url)"
      :video-id="getYouTubeVideoId(url)"
      class="video-player__player"
      :height="height"
      :root-attrs="{
        style: {
          borderRadius: `${borderRadius}px`,
          aspectRatio: 16 / 9,
          width: '100%',
          maxWidth: `${width}px`,
        },
      }"
      :placeholder-attrs="{
        style: {
          objectFit: 'cover',
        },
      }"
    >
      <template #awaitingLoad>
        <div class="play-button">
          <svg height="100%" version="1.1" viewBox="0 0 68 48" width="100%">
            <path
              d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z"
              fill="#f00"
            ></path>
            <path d="M 45,24 27,14 27,34" fill="#fff"></path>
          </svg>
        </div>
      </template>
    </ScriptYouTubePlayer>
  </div>
</template>

<script setup>
const props = defineProps({
  url: { type: String, required: true },
  width: { type: Number, required: false, default: 640 },
  height: { type: Number, required: false, default: 480 },
  borderRadius: { type: Number, required: false, default: 0 },
});

const video = ref();

function getYouTubeVideoId(videoUrl) {
  const url = new URL(videoUrl);

  //example https://www.youtube.com/watch?v=qQmEGSFKB-8
  if (url.pathname === "/watch") {
    return url.searchParams.get("v");
  }

  //example https://www.youtube.com/embed/qQmEGSFKB-8
  //example https://youtu.be/qQmEGSFKB-8
  return url.pathname.split("/").pop();
}
</script>

<style lang="scss">
.video-player {
  position: relative;

  &__player {
    img,
    iframe {
      border-radius: calc(v-bind(borderRadius) * 1px);
    }
  }
}
</style>

<style scoped lang="scss">
.play-button {
  position: absolute;
  @include fixedHW(68px);
  top: 50%;
  left: 50%;

  transform: translate(-50%, -50%);
}
</style>
